import { apiSlice } from "../../app/api/apiSlice";

export const enhancedConditionRemoveAttachmentApiSlice =
	apiSlice.injectEndpoints({
		endpoints: (builder) => ({
			enhancedConditionRemoveAttachment: builder.mutation({
				query: (credentials) => ({
					url: `/api/v1/loan/enhanced_condition_remove_attachment/${credentials?.loanGuid}/`,
					method: "PATCH",
					body: credentials?.data,
				}),
			}),
		}),
	});

export const { useEnhancedConditionRemoveAttachmentMutation } =
	enhancedConditionRemoveAttachmentApiSlice;
